var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Alert", { staticClass: "mb-3", attrs: { type: "info" } }, [
        _c("span", [
          _vm._v(
            " If a user has already been added to the Atomic console through your SSO provider, but not to your organization, you can claim them here. "
          ),
        ]),
      ]),
      _c("Form", {
        attrs: { onSubmit: _vm.claimUser, submitButtonText: "Save" },
        on: { success: _vm.onSuccess, error: _vm.onError },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var disabled = ref.disabled
              return [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "user-email" } }, [
                    _vm._v("Email"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.email,
                        expression: "user.email",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "user-email",
                      type: "email",
                      placeholder: "jappleseed@example.org",
                      required: "",
                      disabled: disabled,
                    },
                    domProps: { value: _vm.user.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "email", $event.target.value)
                      },
                    },
                  }),
                ]),
                !_vm.managesRolesInIdp
                  ? _c("UserRoleSelector", {
                      attrs: { options: _vm.availableRoles },
                      on: { selectionChanged: _vm.updateUserRole },
                    })
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }